import { Cookies } from "react-cookie";
import { Token } from "../utils/setting";
const cookie = new Cookies();

export function clearCookie() {
  cookie.remove(Token);
  window.location.href = "/signin";
  return;
}
export function checkResponse(response, dispatch) {
  if (dispatch && response.error === 1016) {
    var delayInMilliseconds = 5000; //5 second
    dispatch.application.changeSnackbar({
      open: true,
      content: "post_you_dont_have_permission_to_perform_this_action",
      type: "error",
    });
    setTimeout(function () {
      dispatch.application.changeSnackbar({
        open: false,
        content: "",
        type: "success",
      });
    }, delayInMilliseconds);
    return false;
  }
  if (response.code === 401) {
    clearCookie();
    return false;
  } else return true;
}
